module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-down.e0d6fada.svg";